import { gql } from "@apollo/client";

export const CREATE_LOGISTIC_ORDER = gql`
mutation CreateLogisticOrder($data: LogisticInput!, $where: OrderGroupWhereInputOne!) {
    createLogisticOrder(data: $data, where: $where) {
      error
      message
    }
  }
`;

export const SUBSCRIBE_LOGISTIC = gql`
mutation SubscribeLogistic {
  subscribeLogistic {
    error
    message
  }
}
`;